import { WORLD_STATE } from "../data/worldState.js";
import { spawnDamageNumber, spawnPlayerDamageTaken } from "../scenes/features/combat/visuals.js";

export function handleNetworkCombatHit(scene, msg) {
  if (!msg) return;
  const hitX = Number(msg.hitX);
  const hitY = Number(msg.hitY);
  const damage = Number(msg.damage);
  const attackType = typeof msg.attackType === "string" ? msg.attackType : "";
  const attackerHitStopMs = Number.isFinite(Number(msg.attackerHitStopMs)) ? Number(msg.attackerHitStopMs) : 0;
  const targetHitStopMs = Number.isFinite(Number(msg.targetHitStopMs)) ? Number(msg.targetHitStopMs) : 0;

  if (Number.isFinite(hitX) && Number.isFinite(hitY) && Number.isFinite(damage) && damage > 0) {
    if (msg.targetId && msg.targetId === scene.netPlayerId) spawnPlayerDamageTaken(scene, hitX, hitY, damage);
    else if (attackType !== "throw") spawnDamageNumber(scene, hitX, hitY, Math.round(damage));
  }

  if (msg.targetId && msg.targetId !== scene.netPlayerId) {
    const remote = scene.remotePlayers.get(msg.targetId);
    if (remote) {
      const knockbackDir = Number.isFinite(Number(msg.knockbackDir)) ? Number(msg.knockbackDir) : 0;
      const knockbackX = Number.isFinite(Number(msg.knockbackX)) ? Number(msg.knockbackX) : 1.6;
      const targetX = Number(msg.targetX);
      if (Number.isFinite(targetX)) remote.targetX = targetX;
      remote.knockbackVx = knockbackDir * knockbackX;
      if (Number.isFinite(damage) && damage > 0) {
        const hurtMs = Math.max(130, targetHitStopMs + 90);
        remote.hurtUntil = Math.max(remote.hurtUntil || 0, scene.time.now + hurtMs);
      }
    }
  }

  const p = scene.playerEntity;
  if (!p) return;
  if (msg.attackerId === scene.netPlayerId && attackerHitStopMs > 0) {
    p.hitStopTimer = Math.max(p.hitStopTimer || 0, attackerHitStopMs);
  }

  if (msg.targetId !== scene.netPlayerId) return;
  const safeHp = Number.isFinite(Number(msg.hp))
    ? Math.max(0, Math.min(p.maxHp, Number(msg.hp)))
    : p.hp;
  const resolvedDamage = Number.isFinite(damage) ? Math.max(0, damage) : Math.max(0, p.hp - safeHp);
  const knockbackDir = Number.isFinite(Number(msg.knockbackDir)) ? Number(msg.knockbackDir) : 0;
  const targetX = Number(msg.targetX);
  const knockbackX = Number.isFinite(Number(msg.knockbackX)) ? Number(msg.knockbackX) : null;
  const combatMode = typeof msg.combatMode === "string" ? msg.combatMode : "pvp";

  if (safeHp < p.hp && resolvedDamage > 0) {
    p.takeDamage(resolvedDamage, knockbackDir, combatMode);
    if (knockbackX != null) p.knockbackVx = knockbackDir * knockbackX;
  }
  if (targetHitStopMs > 0) {
    p.hitStopTimer = Math.max(p.hitStopTimer || 0, targetHitStopMs);
  }
  if (Number.isFinite(targetX)) p.x = targetX;
  p.hp = safeHp;
  WORLD_STATE.hp = p.hp;
}

export function handleNetworkCombatSwing(scene, msg) {
  if (!msg || msg.attackerId !== scene.netPlayerId) return;
  if (msg.result !== "miss") return;
  const p = scene.playerEntity;
  if (!p) return;
  spawnDamageNumber(scene, p.x + p.w / 2, p.y - 8, "MISS");
}
